// react and mui stuff
import { useLocation, useSearchParams } from 'react-router-dom';

import Button from "@mui/joy/Button"
import Typography from "@mui/joy/Typography"
import Sheet from "@mui/joy/Sheet"

// custom components
import { MetaProps } from '../components/metaprops';
import TwoSidedLayout from '../components/templates/landinglayout';

// data and stuff
import errorCodes from "../data/errorCodes.json"
import { imgSrc } from '../utils/backend';

export default function ErrorPage() {
  const loc = useLocation()
  const [params] = useSearchParams()

  const errCode = errorCodes[params.get("code") as keyof typeof errorCodes] || errorCodes.UNK
  return (
    <Sheet>
      <MetaProps path={loc.pathname}/>
      <TwoSidedLayout reversed>
        <Typography
          level="h1"
          sx={{ fontWeight: 'xl', fontSize: 'clamp(1.875rem, 1.3636rem + 2.1818vw, 3rem)' }}
        >
          ERROR!!!
        </Typography>
        <Typography textColor="text.secondary" sx={{ fontSize: 'lg', lineHeight: 'lg' }}>
          {errCode}
        </Typography>
        <Button
          size="lg"
          startDecorator={<img src={imgSrc("logos/discord.svg")} alt='' height="28px" />}
          sx={{ mt: 2, mb: 1 }}
          onClick={() => window.location.href = `${process.env.REACT_APP_BACKEND}/api/auth/discord?redirect=${encodeURIComponent(loc.pathname)}`}
        >
          Sign in with Discord
        </Button>
      </TwoSidedLayout>
    </Sheet>
  );
}